// Utils
import { isWebBridgeSupported } from '@shopee/web-bridge-sdk';

// Types
import type { AddOrChangeEmailExitHandling } from '@shopee-user/business-customization-types';

export function addOrChangeEmailExitHandling({
  nonce,
  webViewNotifyRefreshTokenAfterChangeCredentials,
  exitWithSuccess,
  safelyRedirectToNextUrlFromQueryString,
}: AddOrChangeEmailExitHandling) {
  if (isWebBridgeSupported()) {
    webViewNotifyRefreshTokenAfterChangeCredentials({ nonce });
    exitWithSuccess();
  } else {
    safelyRedirectToNextUrlFromQueryString({ code: nonce });
  }
}
